<div class="time-account-chart-container">
    <div class="grid">
        <div class="col-12">
            <div class="chart-controls">
                <div class="flex justify-content-between align-items-center">
                    <div class="time-range-selector col-12">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'txZeitKonto.timeRange' | translate }}</mat-label>
                            <mat-select [formControl]="selectedTimeRange">
                                <mat-option *ngFor="let option of timeRangeOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <mat-tab-group class="col-12">
            <mat-tab label="{{ 'txZeitKonto.bookings' | translate }}">
                <div class="chart-wrapper" style="position: relative; height: 350px;">
                    <div *ngIf="loading" class="loading-overlay">
                        <div class="spinner">
                            <mat-spinner diameter="40"></mat-spinner>
                        </div>
                    </div>
                    <canvas #chartCanvas></canvas>
                </div>

                <h4 class="mt-3">{{ 'txZeitKonto.sumsOfTimeRange' | translate }}</h4>
                <div *ngIf="timeAccountSums.length > 0" class="statistics-summary mt-3">
                    <div class="grid">
                        <div class="col-12 md:col-4 statistic-item"
                             [ngClass]="{'selected': selectedDataset === 'target'}"
                             (click)="filterChart('target')">
                            <div class="statistic-card tx-target-time">
                                <div class="statistic-title">{{ 'txZeitKonto.cardTitleSoll' | translate }} ({{ currentTimeRangeOption.label }})</div>
                                <div class="statistic-value">
                                    {{ minutesToTimeString(getTotalMinutes('target', selectedTimeRange.value)) }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-4 statistic-item"
                             [ngClass]="{'selected': selectedDataset === 'difference'}"
                             (click)="filterChart('difference')">
                            <div class="statistic-card tx-difference-time">
                                <div class="statistic-title">{{ 'txZeitKonto.cardTitleDiff' | translate }} ({{ currentTimeRangeOption.label }})</div>
                                <div class="statistic-value">
                                    {{ minutesToTimeString(getTotalMinutes('difference', selectedTimeRange.value)) }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-4 statistic-item"
                             [ngClass]="{'selected': selectedDataset === 'worked'}"
                             (click)="filterChart('worked')">
                            <div class="statistic-card tx-worked-time">
                                <div class="statistic-title">{{ 'txZeitKonto.cardTitleIst' | translate }} ({{ currentTimeRangeOption.label }})</div>
                                <div class="statistic-value">
                                    {{ minutesToTimeString(getTotalMinutes('worked', selectedTimeRange.value)) }}
                                </div>
                            </div>
                        </div>

                        <div *ngIf="this.showProjectChart && this.bde_act" class="col-12 md:col-6 statistic-item"
                             [ngClass]="{'selected': selectedDataset === 'project_diff'}"
                             (click)="filterChart('project_diff')">
                            <div class="statistic-card tx-project-diff-time">
                                <div class="statistic-title">{{ 'txZeitKonto.cardTitleProjectDiff' | translate }}</div>
                                <div class="statistic-value">
                                    {{ minutesToTimeString(getTotalMinutes('project_diff', selectedTimeRange.value)) }}
                                </div>
                            </div>
                        </div>

                        <div *ngIf="this.showProjectChart && this.bde_act" class="col-12 md:col-6 statistic-item"
                             [ngClass]="{'selected': selectedDataset === 'project'}"
                             (click)="filterChart('project')">
                            <div class="statistic-card tx-project-time">
                                <div class="statistic-title">{{ 'txZeitKonto.cardTitleProject' | translate }} ({{ currentTimeRangeOption.label }})</div>
                                <div class="statistic-value">
                                    {{ minutesToTimeString(getTotalMinutes('project', selectedTimeRange.value)) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab [label]="'txZeitKonto.absences' | translate">
                <div class="chart-wrapper" style="position: relative; height: 350px;">
                    <div *ngIf="loading" class="loading-overlay">
                        <div class="spinner">
                            <mat-spinner diameter="40"></mat-spinner>
                        </div>
                    </div>
                    <canvas #absenceChartCanvas></canvas>
                </div>

                <h4 class="mt-3">{{ 'txZeitKonto.absencesInTimeRange' | translate }}</h4>
                <div *ngIf="timeAccountSums.length > 0" class="statistics-summary mt-3">
                    <div class="grid">
                        <!-- Beim Klick auf die Karte wird filterAbsenceChart mit der jeweiligen Abwesenheits-ID aufgerufen -->
                        <div *ngFor="let absenceType of absenceTypes"
                             class="col-12 xl:col-2 lg:col-3 md:col-6 statistic-item"
                             [ngClass]="{'selected': selectedAbsenceDataset === absenceType.id}"
                             (click)="filterAbsenceChart(absenceType.id)">
                            <div class="statistic-card" [ngStyle]="{
								'background-color': absenceType.color + '10',
								'border-left': '4px solid ' + absenceType.color
							}">
                                <div class="statistic-title">{{ absenceType.name }} ({{ currentTimeRangeOption.label }})</div>
                                <div class="statistic-value">
                                    {{ absenceType.totalDays }} {{ (absenceType.totalDays === 1 ? 'txZeitKonto.day' : 'txZeitKonto.days') | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div>
        <mat-card class="info-box mt-3">
            <mat-card-content>
                <div class="flex align-items-center">
                    <mat-icon class="info-icon mr-2">info</mat-icon>
                    <span>{{ 'txZeitKonto.infoNote' | translate }}</span>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
